// React
import { FunctionComponent } from "react";
import { useLocation } from "react-router-dom";
import { ErrorDetails, ErrorPage as SharedErrorPage, Title } from "@fyrstain/hl7-front-library";
// Components
import JunoPage from "../../components/JunoPage/JunoPage";
// Translation
import { useTranslation } from "react-i18next";
import { toPublicUrl } from "../../services/PublicUrl";

type ErrorPageProps = {
  error?: ErrorDetails;
  notFound?: boolean;
};

const getReasonKey = (error: ErrorDetails): string =>
  `status.error.reason.${error.kind}`;

const Error: FunctionComponent<ErrorPageProps> = ({ error: suppliedError, notFound = false }) => {
  const { t } = useTranslation();
  const details = (useLocation().state as { error?: ErrorDetails } | null)?.error;
  const error = suppliedError ?? details ?? {
    kind: notFound ? "not-found" : "generic",
  } as ErrorDetails;
  //////////////////////////////
  //          Content         //
  //////////////////////////////

  return (
    <JunoPage loading={false} fitFooter={true} needsLogin={false}>
      <SharedErrorPage
        description={t(getReasonKey(error))}
        detailsLabel={t("status.error.details")}
        error={error}
        genericMessage={t("status.error.reason.generic")}
        heading={
          <Title
            level={1}
            prefix={t("status.error.oops")}
            content={t("status.error.problem")}
          />
        }
        homeHref={toPublicUrl("/Home")}
        homeLabel={t("status.error.home")}
        httpStatusLabel={(status) => t("status.error.httpStatus", { status })}
        illustration={
          <img
            src={toPublicUrl("/assets/oops.png")}
            alt={t("status.error.oops")}
          />
        }
      />
    </JunoPage>
  );
};

export default Error;
